import { writable } from 'svelte/store';

export const interacted = writable(false);

export const interactedOpenEvaluation = writable(false);